import React from "react";

const SvgChevronLeftBig = props => <svg viewBox="0 0 20 20" {...props}><path fill="currentColor" d="M13.707 18.293a1 1 0 0 1-1.414 1.414l-9-9a1 1 0 0 1 0-1.414l9-9a1 1 0 0 1 1.414 1.414L5.414 10l8.293 8.293z" /></svg>;

export default SvgChevronLeftBig;